import _ from "lodash";
import { NotificationManager } from 'react-notifications';
import { Types } from "../actions/gradeActions";



const defaultState = {
  grades: {}
};

const gradeReducers = (state = defaultState, action) => {
  switch (action.type) {
    case Types.GRADE_UPDATE_LIST: {

      let newState = _.cloneDeep(state);

      newState.grades.gradeList = action.payload.grades;

      return newState;
    }
    case Types.GRADE_APPLY_MODAL: {

      let newState = _.cloneDeep(state);

      newState.grades.apply = action.status;

      return newState;
    }
    case Types.GRADE_OPEN_MODAL: {

      let newState = _.cloneDeep(state);

      newState.grades.modalState = action.status;
      newState.grades.modalGrade = action.grade;

      return newState;
    }
    case Types.GRADE_SAVE_CURRENT_TIMESHEET: {

      let newState = _.cloneDeep(state);

      newState.grades.gradeSaved = true;
      newState.grades.modalState = false;
      newState.grades.modalGrade = null;

      NotificationManager.success(`Your Grade has been saved`,'Success')

      return newState;
    }

    default:
      return state;
  }
};

export default gradeReducers;